import React, { useMemo } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import { actuatorControlPropTypes } from '../../types';

const BinaryControl = ({ feature, value, mini, handleChange }) => {
  const checked = useMemo(() => {
    let val = value;
    if (typeof value === 'number' && typeof feature.value_on !== 'number') {
      val = val ? feature.value_on : feature.value_off;
    }
    return val === feature.value_on;
  }, [feature.value_off, feature.value_on, value]);

  const showLabel =
    !mini &&
    typeof feature.value_off === 'string' &&
    typeof feature.value_on === 'string';

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      {showLabel && <Typography>{feature.value_off}</Typography>}
      <Switch
        checked={checked}
        onChange={e =>
          handleChange(
            feature.property,
            e.target.checked ? feature.value_on : feature.value_off,
          )
        }
        sx={{
          '& .MuiSwitch-track': {
            background: 'lightgrey',
          },
        }}
        size={mini ? 'small' : 'medium'}
      />
      {showLabel && <Typography>{feature.value_on}</Typography>}
    </Stack>
  );
};

BinaryControl.propTypes = actuatorControlPropTypes;

export default BinaryControl;
